// extracted by mini-css-extract-plugin
export var actionButton = "_ib-t";
export var buttonContainer = "_ib-0";
export var buttonContainer2 = "_ib-1";
export var buttonSection = "_ib-2";
export var details = "_ib-3";
export var dropdownItem = "_ib-5";
export var dropdownItemsContainer = "_ib-4";
export var fileInput = "_ib-r";
export var headerButton = "_ib-6";
export var icon = "_ib-7";
export var input = "_ib-8";
export var macroListItem = "_ib-9";
export var mainContent = "_ib-a";
export var microText = "_ib-b";
export var modal = "_ib-w";
export var optionsButton = "_ib-c";
export var paperclip = "_ib-s";
export var pillContent = "_ib-d";
export var preview = "_ib-e";
export var preview2 = "_ib-f";
export var quillEditor = "_ib-q";
export var selectedMacro = "_ib-g";
export var sidebar = "_ib-h";
export var sidebarHeader = "_ib-j";
export var sidebarList = "_ib-i";
export var sidebarListItem = "_ib-k";
export var sidebarSearch = "_ib-l";
export var snoozeDurationWrapper = "_ib-v";
export var statusPillContainer = "_ib-m";
export var tagsContainer = "_ib-n";
export var unselectedMacro = "_ib-o";
export var variable = "_ib-u";
export var wrapper = "_ib-p";